import { useEffect, useState } from 'react';
import { loadCachedProfile } from './loadCachedProfile';

const BRAND_PROFILE_CACHE_KEY = 'brand_profile_cache';
const BRAND_PROFILE_CACHE_TIMESTAMP_KEY = 'brand_profile_cache_timestamp';

const DEFAULT_LABEL = 'Millet';

const fetchBrandCompanyName = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/brand/profile`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) return null;
  const data = await response.json();
  return String(data.company_name || '').trim() || null;
};

export default function useDashboardSidebarToggleLabel(userType) {
  const [label, setLabel] = useState(null);

  useEffect(() => {
    if (userType !== 'brand') {
      setLabel(null);
      return undefined;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      setLabel(DEFAULT_LABEL);
      return undefined;
    }

    let cancelled = false;

    const applyLabel = (nextLabel) => {
      if (!cancelled) {
        setLabel(nextLabel || DEFAULT_LABEL);
      }
    };

    const cacheLoaded = loadCachedProfile(
      BRAND_PROFILE_CACHE_KEY,
      BRAND_PROFILE_CACHE_TIMESTAMP_KEY,
      (profile) => applyLabel(profile.companyName),
    );
    if (cacheLoaded) return undefined;

    fetchBrandCompanyName(token)
      .then((companyName) => applyLabel(companyName))
      .catch(() => applyLabel(DEFAULT_LABEL));

    return () => { cancelled = true; };
  }, [userType]);

  return label;
}
